// extracted by mini-css-extract-plugin
export default {"constructionContainer":"constructionNew_constructionContainer__oQsuj"};